// react
import { useState } from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui icons
import FiberNewOutlinedIcon from '@mui/icons-material/FiberNewOutlined';

// material ui
import { IconButton, Tooltip } from '@mui/material';

// relative
import ReleaseNotesDialog from './ReleaseNotesDialog';

/**
 * ReleaseNotesButton - An icon button for the AppBar that shows release notes
 * Much less intrusive than a full banner
 * @param {Object} props
 * @param {string} props.releaseNotes - The release notes content to display
 * @param {string} props.version - Version number
 */
const ReleaseNotesButton = ({ releaseNotes, version }) => {
  const { t } = useTranslation('feedback');
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClick = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <Tooltip title={t('release_notes.title')}>
        <IconButton
          onClick={handleClick}
          sx={{
            borderRadius: 2,
            // backgroundColor: alpha('#1ab165', 0.1),
            // ':hover': {
            //   backgroundColor: alpha('#1ab165', 0.2),
            // },
          }}
        >
          <FiberNewOutlinedIcon />
        </IconButton>
      </Tooltip>

      <ReleaseNotesDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        releaseNotes={releaseNotes}
        version={version}
      />
    </>
  );
};

export default ReleaseNotesButton;
